var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreaTuPropiosEventos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 157.832,
    height: 137.611,
    viewBox: "0 0 157.832 137.611",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;stroke-dasharray:1 12;}.a,.b{stroke:#f0f4f9;stroke-miterlimit:10;}.b{fill:#fdfffc;stroke-width:2px;}.c{fill:#7821a0;}.d{fill:#a4c2f7;}.e{fill:#d4e1f4;}.f{fill:#e3e7f2;}.g{fill:#efd2ff;}.h{fill:#f1eaf4;}.i{fill:#fff;}.j{fill:#264ecc;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 2.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 66.306,
    cy: 66.306,
    r: 66.306,
    transform: "translate(21.721)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 44.585)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 21.721,
    cy: 21.721,
    r: 21.721
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M7.434,13.718a1.43,1.43,0,0,1-1.1-.473L.447,7.2A1.524,1.524,0,0,1,.5,5a1.524,1.524,0,0,1,2.206.052L7.487,9.988,17.574.427a1.561,1.561,0,1,1,2.154,2.259L8.538,13.3A1.806,1.806,0,0,1,7.434,13.718Z",
    transform: "translate(11.432 14.862)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-123.911 -867.857)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(179.391 908.425)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.089 1.089)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M244.422,921.591v33.752a3.263,3.263,0,0,1-3.267,3.267H184.538a3.263,3.263,0,0,1-3.267-3.267V921.591Z",
    transform: "translate(-181.271 -915.058)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M241.155,921.591v33.752a3.262,3.262,0,0,1-3.266,3.267H184.538a3.263,3.263,0,0,1-3.267-3.267V921.591Z",
    transform: "translate(-181.271 -915.058)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M245.637,1001.7l6.533,6.533a2.171,2.171,0,1,1-3.07,3.07l-6.533-6.533Z",
    transform: "translate(-207.083 -948.79)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 9.799,
    cy: 9.799,
    r: 9.799,
    transform: "translate(21.776 39.197)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.776 39.197)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "h",
    cx: 8.166,
    cy: 9.799,
    rx: 8.166,
    ry: 9.799
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 5.444,
    cy: 5.444,
    r: 5.444,
    transform: "translate(4.355 4.355)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M244.422,913.573v5.444H181.271v-5.444a3.263,3.263,0,0,1,3.267-3.267h56.617a3.263,3.263,0,0,1,3.267,3.267Z",
    transform: "translate(-181.271 -910.306)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M241.155,913.573v5.444H181.271v-5.444a3.263,3.263,0,0,1,3.267-3.267h53.351a3.262,3.262,0,0,1,3.266,3.267Z",
    transform: "translate(-181.271 -910.306)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M194.239,932.876l1.682,3.584,3.762.575-2.722,2.789.642,3.939-3.364-1.86-3.364,1.86.642-3.939-2.722-2.789,3.762-.575Z",
    transform: "translate(-184.439 -919.81)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M194.239,957.327l1.682,3.584,3.762.575-2.722,2.789.642,3.939-3.364-1.86-3.364,1.86.642-3.939-2.722-2.789,3.762-.575Z",
    transform: "translate(-184.439 -930.107)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M184.538,953.858H187.8a3.261,3.261,0,0,1-3.266-3.266V913.573a3.262,3.262,0,0,1,3.266-3.267h-3.266a3.263,3.263,0,0,0-3.267,3.267v37.019a3.263,3.263,0,0,0,3.267,3.267Z",
    transform: "translate(-181.271 -910.306)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M181.568,925.353v31.575h-2.178V925.353Z",
    transform: "translate(-179.391 -915.553)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M231.063,983.658a6.533,6.533,0,1,0,6.533,6.533A6.533,6.533,0,0,0,231.063,983.658Zm0,10.888a4.355,4.355,0,1,1,4.355-4.355A4.355,4.355,0,0,1,231.063,994.546Z",
    transform: "translate(-198.399 -940.106)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M180.485,940.7a1.147,1.147,0,0,0,.773-.316,1.1,1.1,0,0,0,0-1.546l-.163-.131a.832.832,0,0,0-.2-.1.691.691,0,0,0-.2-.065,1.6,1.6,0,0,0-.218-.022,1.142,1.142,0,0,0-.773.316,1.073,1.073,0,0,0,.359,1.774A1.083,1.083,0,0,0,180.485,940.7Z",
    transform: "translate(-179.396 -921.097)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M240.363,908.425H183.746a4.36,4.36,0,0,0-4.355,4.356v9.8a1.089,1.089,0,1,0,2.177,0v-3.267H233.83a1.089,1.089,0,1,0,0-2.177H181.568v-4.355a2.18,2.18,0,0,1,2.178-2.178h56.617a2.18,2.18,0,0,1,2.178,2.178v4.355h-4.355a1.089,1.089,0,1,0,0,2.177h4.355V949.8a2.181,2.181,0,0,1-2.178,2.178H220.744a10.846,10.846,0,0,0-17.378,0H183.746a2.181,2.181,0,0,1-2.178-2.178V931.29a1.089,1.089,0,1,0-2.177,0V949.8a4.359,4.359,0,0,0,4.355,4.355h18.336a10.874,10.874,0,0,0,15.007,14l4.639,4.638a3.26,3.26,0,1,0,4.609-4.612l-4.637-4.637a10.818,10.818,0,0,0,.328-9.39h18.336a4.359,4.359,0,0,0,4.355-4.355V912.781A4.36,4.36,0,0,0,240.363,908.425ZM203.344,958.51a8.711,8.711,0,1,1,8.711,8.711A8.711,8.711,0,0,1,203.344,958.51ZM224.8,969.727a1.06,1.06,0,0,1,0,1.525,1.093,1.093,0,0,1-1.532,0l-4.321-4.321a11,11,0,0,0,1.531-1.531Z",
    transform: "translate(-179.391 -908.425)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M218.1,915.949a1.089,1.089,0,1,0,0,2.177h19.6a1.089,1.089,0,1,0,0-2.177Z",
    transform: "translate(-195.231 -911.593)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M199.923,935.9a1.088,1.088,0,0,0-.867-.731l-3.188-.487-1.436-3.058a1.089,1.089,0,0,0-1.971,0l-1.435,3.058-3.188.487a1.088,1.088,0,0,0-.614,1.836l2.338,2.4-.554,3.4a1.089,1.089,0,0,0,1.6,1.128l2.838-1.568,2.838,1.568a1.089,1.089,0,0,0,1.6-1.128l-.555-3.4,2.338-2.4A1.089,1.089,0,0,0,199.923,935.9Zm-4.534,2.375a1.09,1.09,0,0,0-.3.936l.281,1.727-1.4-.775a1.088,1.088,0,0,0-1.053,0l-1.4.775.282-1.727a1.091,1.091,0,0,0-.3-.936L190.262,937l1.667-.255a1.09,1.09,0,0,0,.821-.614l.7-1.484.7,1.484a1.088,1.088,0,0,0,.82.614l1.668.255Z",
    transform: "translate(-182.559 -917.929)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M187.223,961.453l2.338,2.4-.554,3.4a1.089,1.089,0,0,0,1.6,1.128l2.838-1.569,2.838,1.569a1.089,1.089,0,0,0,1.6-1.128l-.554-3.4,2.338-2.4a1.089,1.089,0,0,0-.614-1.836l-3.188-.487-1.436-3.058a1.089,1.089,0,0,0-1.971,0l-1.435,3.058-3.188.487a1.089,1.089,0,0,0-.615,1.836Zm4.706-.258a1.088,1.088,0,0,0,.821-.614l.7-1.484.7,1.484a1.087,1.087,0,0,0,.82.614l1.668.255-1.242,1.272a1.092,1.092,0,0,0-.3.936l.281,1.727-1.4-.775a1.085,1.085,0,0,0-1.053,0l-1.4.775.282-1.727a1.09,1.09,0,0,0-.3-.936l-1.242-1.272Z",
    transform: "translate(-182.559 -928.226)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M216.215,935.054h6.533a1.089,1.089,0,0,0,0-2.178h-6.533a1.089,1.089,0,0,0,0,2.178Z",
    transform: "translate(-194.439 -918.721)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M216.215,942.577h14.155a1.089,1.089,0,0,0,0-2.178H216.215a1.089,1.089,0,1,0,0,2.178Z",
    transform: "translate(-194.439 -921.889)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M256.9,940.4h-8.71a1.089,1.089,0,1,0,0,2.178h8.71a1.089,1.089,0,0,0,0-2.178Z",
    transform: "translate(-207.904 -921.889)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M275.114,942.577a1.089,1.089,0,1,0,0-2.178h-4.355a1.089,1.089,0,1,0,0,2.178Z",
    transform: "translate(-217.408 -921.889)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M250.862,949.011a1.088,1.088,0,0,0,1.088,1.089h15.243a1.089,1.089,0,1,0,0-2.177H251.95a1.087,1.087,0,0,0-1.088,1.088Z",
    transform: "translate(-209.488 -925.058)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M238.091,947.923h-8.71a1.089,1.089,0,1,0,0,2.177h8.71a1.089,1.089,0,1,0,0-2.177Z",
    transform: "translate(-199.983 -925.058)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M216.215,950.1h3.266a1.089,1.089,0,1,0,0-2.177h-3.266a1.089,1.089,0,1,0,0,2.177Z",
    transform: "translate(-194.439 -925.058)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M216.215,961.385h6.533a1.089,1.089,0,1,0,0-2.177h-6.533a1.089,1.089,0,1,0,0,2.177Z",
    transform: "translate(-194.439 -929.81)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M216.215,968.908h14.155a1.089,1.089,0,0,0,0-2.177H216.215a1.089,1.089,0,1,0,0,2.177Z",
    transform: "translate(-194.439 -932.978)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M248.189,968.908h8.71a1.089,1.089,0,1,0,0-2.177h-8.71a1.089,1.089,0,1,0,0,2.177Z",
    transform: "translate(-207.904 -932.978)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M275.114,966.731h-4.355a1.089,1.089,0,1,0,0,2.177h4.355a1.089,1.089,0,1,0,0-2.177Z",
    transform: "translate(-217.408 -932.978)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M267.194,974.254H251.95a1.089,1.089,0,0,0,0,2.178h15.243a1.089,1.089,0,1,0,0-2.178Z",
    transform: "translate(-209.488 -936.146)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M216.215,976.432h2.178a1.089,1.089,0,0,0,0-2.178h-2.178a1.089,1.089,0,1,0,0,2.178Z",
    transform: "translate(-194.439 -936.146)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M189.11,916.26a1.25,1.25,0,0,0-.229.359.911.911,0,0,0-.087.414,1.074,1.074,0,0,0,.076.413,1.642,1.642,0,0,0,.24.359,1.077,1.077,0,0,0,1.187.229.982.982,0,0,0,.588-.588,1.087,1.087,0,0,0-1.775-1.187Z",
    transform: "translate(-183.35 -911.589)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M196.633,916.26a1.262,1.262,0,0,0-.229.359.911.911,0,0,0-.087.414,1.074,1.074,0,0,0,.075.413,1.662,1.662,0,0,0,.24.359,1.077,1.077,0,0,0,1.187.229.982.982,0,0,0,.588-.588,1.1,1.1,0,0,0,.087-.413,1.089,1.089,0,0,0-1.862-.773Z",
    transform: "translate(-186.519 -911.589)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M204.157,916.26a1.238,1.238,0,0,0-.229.359.9.9,0,0,0-.087.414,1.064,1.064,0,0,0,.076.413,1.621,1.621,0,0,0,.24.359,1.076,1.076,0,0,0,1.186.229.981.981,0,0,0,.588-.588,1.087,1.087,0,0,0-1.774-1.187Z",
    transform: "translate(-189.687 -911.589)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(201.167 947.622)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M231.055,983.659a6.533,6.533,0,1,0,6.533,6.533A6.533,6.533,0,0,0,231.055,983.659Zm0,10.889a4.356,4.356,0,1,1,4.356-4.356A4.356,4.356,0,0,1,231.055,994.548Z",
    transform: "translate(-220.172 -979.303)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M242.174,996.7l-4.638-4.637q.15-.287.282-.579c.023-.052.044-.105.067-.157.063-.145.124-.291.181-.438.021-.056.039-.111.06-.167.054-.148.106-.3.153-.446.016-.05.03-.1.044-.149.048-.159.093-.318.133-.479.01-.041.019-.082.029-.123.041-.172.078-.345.11-.519.006-.03.011-.061.016-.091q.049-.28.085-.562l.007-.058q.036-.3.054-.6l0-.026a10.806,10.806,0,0,0-.893-4.993h.058a10.909,10.909,0,0,0-1.261-2.178h-.079a10.847,10.847,0,0,0-17.381,0h-.079a10.913,10.913,0,0,0-1.262,2.178h.058a10.842,10.842,0,0,0-.859,5.414c0,.022,0,.043.006.065.017.171.039.343.065.513,0,.025.008.05.012.076q.071.449.18.89c.015.061.029.123.045.184.038.141.077.282.12.421.027.089.058.178.087.266.065.2.135.388.212.58.047.116.094.232.144.347s.091.2.14.305c.074.154.151.306.232.456q.072.135.148.268.141.244.293.482c.045.069.09.137.136.2.129.19.261.377.4.559l.048.061c.145.185.3.364.457.541q.066.074.134.146c.173.185.35.367.537.542a10.876,10.876,0,0,0,12.468,1.68l4.638,4.639a3.261,3.261,0,1,0,4.61-4.612Zm-14.283-.961a8.711,8.711,0,1,1,8.711-8.711A8.722,8.722,0,0,1,227.891,995.735Zm12.744,4.031a1.092,1.092,0,0,1-1.532,0l-4.283-4.283-.038-.038a10.962,10.962,0,0,0,1.531-1.531l.037.037h0l4.289,4.288a1.06,1.06,0,0,1,0,1.525Z",
    transform: "translate(-217.008 -976.135)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreaTuPropiosEventos);
export default __webpack_public_path__ + "static/media/crea_tu_propios_eventos.334d495f58079091c4c60f6abc311c2c.svg";
export { ForwardRef as ReactComponent };